<template>
    <TransactionalScreen :backgrounds="backgrounds" @setLanguage="setLanguage" :title="$t('login.Login')">
        <!-- Form -->
        <Form :errors="errors" :displayRegisterLink="displayRegisterLink" :loading="loading" @login="response => $emit('login', response)" />

        <!-- Links -->
        <div class="mt-3 text-center text-muted">
            <a href="#" @click.prevent="$emit('lostPassword')">{{ $t('login.Lost password?') }}</a>
            <span v-if="displayRegisterLink">
                - <a href="#" @click.prevent="$emit('register')">{{ $t('login.Register') }}</a>
            </span>
        </div>
    </TransactionalScreen>
</template>

<script>
    import TransactionalScreen from '../TransactionalScreen'
    import Form from './Form'

    export default {
        props: {
            backgrounds: {
                type: Array,
                required: false
            },
            errors: {
                type: Object,
                required: false,
                default: () => { return {} }
            },
            displayRegisterLink: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Form,
            TransactionalScreen
        },
        methods: {
            setLanguage(lang) {
                this.$emit('setLanguage', lang)
            }
        }
    }
</script>
